import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  MODELO_DE_FOLLOWUP,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MODELO_DE_FOLLOWUP
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MODELO_DE_FOLLOWUP,
    id,
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [MODELO_DE_FOLLOWUP],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [MODELO_DE_FOLLOWUP],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [MODELO_DE_FOLLOWUP],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [MODELO_DE_FOLLOWUP],
    id
  );
}
